import React from "react";

export default function ReqBox({ label, value, sub }) {
  return (
    <div className="col-4">
      <div className="bg-white border rounded-3 p-2 text-center h-100">
        <div
          className="marketing_level_text_muted fw-bold text-uppercase"
          style={{ fontSize: 9 }}
        >
          {label}
        </div>
        <div className="fw-bold small">{value}</div>
        {sub && (
          <div
            className={
              sub.includes("✓")
                ? "marketing_level_text_green fw-semibold"
                : "marketing_level_text_gold fw-semibold"
            }
            style={{ fontSize: 10 }}
          >
            {sub}
          </div>
        )}
      </div>
    </div>
  );
}

